import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryFeeding = () => {
  return <CategoryBase baseEndpoint="category_feeding" />;
};

export default CategoryFeeding;
